import { jsx } from "panel";
import { TagEl } from "common/components/tag";
import { TagSize } from "common/components/tag/types";
import { ButtonEl } from "common/components/button";
import { TagInputEl } from "common/components/tag-input";
import { SlackAuthProblem } from "./types";
const containerSelector = `.mp-slack-channel-selector-container`;
function RenderSlackAuthProblem({ cmp }) {
  const { slackAuthProblem, selectedChannels } = cmp.state;
  const { t } = cmp.getContext(`i18n`);
  const hasChannels = !!selectedChannels.size;
  const message = slackAuthProblem === SlackAuthProblem.MissingSlackAuthScopesException ? t(`subscriptions.reauthorize-slack-app`) : t(`subscriptions.add-mixpanel-to-slack`);
  return /* @__PURE__ */ jsx("div", { sel: containerSelector }, hasChannels && /* @__PURE__ */ jsx("div", { sel: ".mp-slack-channel-selector-no-auth-channels" }, /* @__PURE__ */ jsx(ChannelsAsTags, { cmp, isReadonly: true })), /* @__PURE__ */ jsx(
    ButtonEl,
    {
      attrs: {
        icon: `slack-logo`,
        href: `/slack/oauth?slack_v2=true&use_internal_landing=true`,
        target: `_blank`,
        ...cmp.attr(`button-theme`) ? { theme: cmp.attr(`button-theme`) } : {},
        ...cmp.attr(`button-full-width`) ? {
          "style-override": `a.mp-button-container .mp-button-content {
              flex: none; width: auto;
            }
            :host {
              width: 100%;
            }
            `
        } : {}
      },
      on: {
        click: cmp.handleReauthorizeClick
      }
    },
    message
  ));
}
function RenderReadonly({ cmp }) {
  const channelArray = [...cmp.state.selectedChannels];
  return /* @__PURE__ */ jsx("div", { sel: containerSelector }, channelArray.length !== 0 ? /* @__PURE__ */ jsx(ChannelsAsTags, { cmp, isReadonly: true }) : /* @__PURE__ */ jsx("div", { sel: ".mp-slack-channel-selector-no-slack-channels" }, cmp.getContext(`i18n`).t(`subscriptions.no-slack-channels`)));
}
function ChannelsAsTags({ cmp, isReadonly }) {
  const channelArray = [...cmp.state.selectedChannels];
  return /* @__PURE__ */ jsx(null, null, channelArray.map(([channelId, channel]) => {
    return /* @__PURE__ */ jsx(
      TagEl,
      {
        attrs: {
          removable: !isReadonly,
          clickable: false,
          size: TagSize.Small,
          "tag-name": channel.name
        },
        key: `channel-${channelId}`,
        on: { remove: () => cmp.deselectChannelById(channel.id) }
      }
    );
  }));
}
export function template() {
  if (this.attr(`is-readonly`)) {
    return /* @__PURE__ */ jsx(RenderReadonly, { cmp: this });
  }
  if (this.state.slackAuthProblem) {
    return /* @__PURE__ */ jsx(RenderSlackAuthProblem, { cmp: this });
  }
  return /* @__PURE__ */ jsx("div", { sel: containerSelector }, /* @__PURE__ */ jsx(
    TagInputEl,
    {
      attrs: {
        id: `picker`,
        tags: this.getChannelsAsTags(),
        elref: `sharingTagInput`,
        placeholder: this.getContext(`i18n`).t(`subscriptions.channel-placeholder`),
        "min-tags": 0,
        disable: this.attr(`is-readonly`),
        multiline: true
      },
      on: {
        change: this.handleTagInputChange,
        clickMenuItem: this.handleItemClick
      },
      props: {
        menuSections: this.getSlackChannelsForItemsMenu()
      }
    }
  ));
}
